import React from "react";
import Svg from "@natera/material/lib/svg";
import CalendarIcon from "@assets/svg/icons/calendar.svg";

const DateIconTriggerButton = () => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      const dateInput = document.querySelector<HTMLInputElement>("#date");
      dateInput?.focus();
      dateInput?.click();
    }
  };

  return (
    <button
      className="date-icon-button"
      tabIndex={0}
      onKeyDown={handleKeyDown}
      aria-label="calendar-button"
    >
      <Svg content={CalendarIcon} />
    </button>
  );
};

export default DateIconTriggerButton;
